const GL_MARK_ATTRIBUTE = 'gl-auto-seo'

export const GlAutoSeoTypes = {
  CAROUSEL: 'carousel',
  CAROUSEL_ITEM: 'carouselItem'
}

export function addJsonldToHead (content) {
  addScriptElToHead(content, 'application/ld+json')
}

// TODO: implement type based purge
export function addScriptElToHead(scriptElContent, scriptType) {
  Array.from(document.querySelectorAll(`[${GL_MARK_ATTRIBUTE}]`))
    .map(el => el.parentNode.removeChild(el))
  if (scriptElContent) {
    const scriptEl = document.createElement('script')
    scriptEl.type = scriptType
    scriptEl.text = scriptElContent
    scriptEl.setAttribute(GL_MARK_ATTRIBUTE, 'geekline-seo')
    document.head.appendChild(scriptEl)
  }
}
